export enum TrainingProviderEventSortFieldAndDirection {
    /** Sorts events by their event ID in ascending order. */
    EventIdAscending = 1,

    /** Sorts events by their event ID in descending order. */ 
    EventIdDescending = 2,

    /** Sorts events by their start date in ascending order. */
    StartDateAscending = 3,

    /** Sorts events by their start date in descending order. */ 
    StartDateDescending = 4,
}